// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__23bjs","row":"Node_row__37Izu","label":"Node_label__EWRiK","footer":"Node_footer__2P18x"};